export default __webpack_public_path__ + "static/media/hide.1a736266.svg";